module.exports = "<app-page-header [pageTitle]=\"'Pages.repair'\"></app-page-header>\r\n\r\n<app-repair-steps></app-repair-steps>"